import React, { useState } from 'react';
import './header.scss';
import menu from '../../images/menu.svg'
import logo from '../../images/logo.png'
import { Link } from 'react-router-dom';
import { ResumeData } from '../../Store';
const Header = () => {
    const [activeMenu, setActiveMenu] = useState(false);

    const handleMenu = () => {
        setActiveMenu(!activeMenu);
    }

    const resume = ResumeData;
    return (
        <header className="header">
            <div className="container">
                 <div className="header-flex">
                <div className="logo">
                        <Link to="/"><img className="logo-img" src={logo} alt="logo"/></Link>
                </div>
                    <img className="hamburger-menu" src={menu} alt="menu" onClick={handleMenu}/>
                <nav className={activeMenu && "active"}>
                    <ul>
                        <li><Link to="/about">01. About</Link></li>
                        <li><Link to="/work">02. Experience</Link></li>
                        <li><Link to="/blog">03. Blog</Link></li>
                        <li><Link to="/contact">04. Contact</Link></li>
                        <li><a target="_blank" href={resume} className="btn btn-primary">Resume</a></li>
                    </ul>
                </nav>
            </div>
           </div>
        </header>
    );
};

export default Header;